import { useTranslation } from 'react-i18next';
import styles from './WalkTime.module.css';

interface Props {
  walkTime: number;
}

export const WalkTime = ({ walkTime }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.walkTime}>
      <img className={styles.icon} src="/static/images/map/walker_blue.svg" alt="walk" />
      <span className={styles.text}>{t('{{time}} min', { time: walkTime })}</span>
    </div>
  );
};
